import { TAGS_FAMILY_SEPARATOR } from "src/components/features/medium/AssetsFilter/components/AssetsFilterTags/AssetsFilterTags.constants";
import { AssetNameWithIcon } from "src/components/resources/AssetNameWithIcon/AssetNameWithIcon";
import { AwsLogoIcon, DBXIcon, SparkIcon } from "@ui-icons";
import type { LabelPattern } from "./Tag.types";

/**
 * Label pattern configurations for Tag.
 * Patterns are evaluated in array order.
 * The first matching pattern's renderer will be used.
 */
export const LABEL_PATTERNS: LabelPattern[] = [
  {
    test: (label) => label.startsWith("pipeline:"),
    render: (label) => (
      <AssetNameWithIcon
        name={label.split(TAGS_FAMILY_SEPARATOR)[1]}
        type="pipeline"
        sx={{ color: "inherit", fontSize: 14 }}
      />
    ),
  },
  {
    test: (label) => label.toLowerCase().endsWith("aws"),
    render: (label) => (
      <>
        {label.split(TAGS_FAMILY_SEPARATOR)[0]}:{" "}
        <AwsLogoIcon sx={{ color: "inherit", fontSize: 22 }} />
      </>
    ),
  },
  {
    test: (label) => label.toLowerCase().endsWith("databricks"),
    render: (label) => (
      <>
        {label.split(TAGS_FAMILY_SEPARATOR)[0]}:{" "}
        <DBXIcon sx={{ color: "inherit", fontSize: 18, filter: "grayscale(1)" }} />
      </>
    ),
  },
  {
    test: (label) => label.startsWith("Databricks"),
    render: (label) => (
      <>
        <DBXIcon
          sx={{ color: "grey.600", fontSize: 18, mr: 0.2, filter: "grayscale(1)" }}
        />
        {label.split("Databricks")[1]}
      </>
    ),
  },
  {
    test: (label) => label.startsWith("Spark"),
    render: (label) => (
      <>
        <SparkIcon sx={{ color: "grey.600", fontSize: 18, mr: 0.2 }} />
        {label.split("Spark")[1]}
      </>
    ),
  },
];
